import * as Actions from "../redux/nmhaSession";

import { put, takeLatest } from "redux-saga/effects";

export function* setMapMode({ payload }) {
  try {
    yield put(Actions.setMapModeSuccess(payload));
  } catch (error) {
    yield put(Actions.nmhaSessionRequestFailed(error));
  }
}

export function* setGraphModeFilter({ payload }) {
  try {
    yield put(Actions.setGraphModeFilterSuccess(payload));
  } catch (error) {
    yield put(Actions.nmhaSessionRequestFailed(error));
  }
}

export function* setHeatModeFilter({ payload }) {
  try {
    yield put(Actions.setHeatModeFilterSuccess(payload));
  } catch (error) {
    yield put(Actions.nmhaSessionRequestFailed(error));
  }
}

export function* setStateModeFilter({ payload }) {
  try {
    yield put(Actions.setStateModeFilterSuccess(payload));
  } catch (error) {
    yield put(Actions.nmhaSessionRequestFailed(error));
  }
}
export function* setShowClientStates({ payload }) {
  try {
    yield put(Actions.setShowClientStatesSuccess(payload));
  } catch (error) {
    yield put(Actions.nmhaSessionRequestFailed(error));
  }
}
export function* setShowZipCodes({ payload }) {
  try {
    yield put(Actions.setShowZipCodesSuccess(payload));
  } catch (error) {
    yield put(Actions.nmhaSessionRequestFailed(error));
  }
}

//  saga
export default function* mnhaDataSaga() {
  yield takeLatest(Actions.setMapModeRequest, setMapMode);
  yield takeLatest(Actions.setGraphModeFilterRequest, setGraphModeFilter);
  yield takeLatest(Actions.setHeatModeFilterRequest, setHeatModeFilter);
  yield takeLatest(Actions.setStateModeFilterRequest, setStateModeFilter);
  yield takeLatest(Actions.setShowClientStatesRequest, setShowClientStates);
  yield takeLatest(Actions.setShowZipCodesRequest, setShowZipCodes);
}
